/* eslint-disable filename-export/match-default-export */

import React from 'react';
import pt from 'prop-types';
import ReactAceEditor from './react-ace-editor';
import useAceEditorProps from './useAceEditorProps';
import buildHiddenInputProps from './buildHiddenInputProps';

export default function BaseAceCodeEditor(props) {
  const aceEditorProps = useAceEditorProps(props);
  const inputProps = buildHiddenInputProps(props);
  return (
    <>
      <input {...inputProps} />
      <ReactAceEditor {...aceEditorProps} />
    </>
  );
}

BaseAceCodeEditor.propTypes = {
  name: ReactAceEditor.propTypes.name,
  lang: ReactAceEditor.propTypes.mode,
  value: ReactAceEditor.propTypes.value,
  options: ReactAceEditor.propTypes.setOptions,
  rows: ReactAceEditor.propTypes.maxLines,
  width: ReactAceEditor.propTypes.width,
  readOnly: ReactAceEditor.propTypes.readOnly,
  debounceChangePeriod: ReactAceEditor.propTypes.debounceChangePeriod,
  id: pt.string,
  testId: pt.string,
  foldable: pt.bool,
  hasError: pt.bool,
  // not using AceEditor.propTypes for these events as our fn signature is different
  onBlur: pt.func,
  onChange: pt.func,
  onFocus: pt.func,
  onInput: pt.func,
  // Caller hook that receives the underlying ace editor instance once
  // mounted + internally configured. Use for custom completers, markers,
  // or key bindings that need the live editor ref.
  onEditorMount: pt.func,
};
